import React from 'react';
import LazyLoad from 'react-lazyload';

const Feature = ({ title, description, image }) => {
	return (
		<div className="feature">
			{
				image !== undefined ?
				(
					<LazyLoad once={ true } offset={ 200 }>
						<img
							src={ image }
							alt={ title }
						/>
					</LazyLoad>
				) : null
			}
			<h3 className="feature-title">
				{ title }
			</h3>
			<p>
				{ description }
			</p>
		</div>
	);
};

export default Feature;


// WEBPACK FOOTER //
// ./src/pages/common/Feature.js